<template>
  <div>
    <section-definition title="Recesso de Quadro Horário" event-update="pesquisar"></section-definition>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Gerenciar Recesso de Quadro Horário</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <modal-cadastro-qh-recesso :plano="plano" @qhRecessoCadastrado="cadastroEfetuado = $event"/>
      <v-divider class="mx-2" inset vertical></v-divider>
      <modal-resumo-qh-recesso :plano="plano" :tem-recessos="recessos.length > 0"/>
    </v-toolbar>
    <v-container fluid>
      <v-form ref="form" class="hidden-sm-and-down">
        <v-layout align-center row fill-height justify-space-between>
          <v-flex xs12 sm6 md2>
            <v-select v-model="filtro.ano" :items="anos" label="Ano" clearable
              @change="aoSelecionarAno"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-select v-model="filtro.numero" :items="numeros" label="Número" clearable
              :disabled="!filtro.ano" @change="aoSelecionarNumero"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Data Início" disabled v-model="plano.dataInicio"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Data Fim" disabled v-model="plano.dataFim"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-text-field color="primary" label="Descrição" disabled v-model="plano.descricao"></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
      <div class="qh-recessos-scroll">
        <v-data-table :loading="loading" :headers="headers" :items="recessos" class="elevation-1" hide-actions>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.data }}</td>
            <td>{{ props.item.diaSemana }}</td>
            <td>{{ props.item.funcao }}</td>
            <td>{{ props.item.descricao }}</td>
            <td>
              <v-icon v-if="plano.ativo" title="Editar" medium class="mr-2" @click="editar(props.item)">
                edit
              </v-icon>
              <v-icon v-if="plano.ativo" title="Excluir" medium class="mr-2" @click="excluir(props.item)">
                delete
              </v-icon>
            </td>
          </template>
          <template slot="no-data">
            Nenhum recesso cadastrado para o plano!
          </template>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>
<script>
import qhRecessoService from "@/service/qh/QhRecessoService";
import qhPlanoService from "@/service/qh/QhPlanoService";
import QhPlanoResumo from "@/model/qh/QhPlanoResumo";
import EventBus from "@/utils/EventBus.js";
import ModalCadastroQhRecesso from "./ModalCadastroQhRecesso";
import ModalResumoQhRecesso from "./ModalResumoQhRecesso";
export default {
  components: {
    ModalCadastroQhRecesso,
    ModalResumoQhRecesso
  },
  data() {
    return {
      loading: false,
      cadastroEfetuado: false,
      recessos: [],
      anos: [],
      numeros: [],
      filtro: { ano: null, numero: null },
      plano: new QhPlanoResumo(),
      headers: [
        { text: "Data", align: "left", sortable: false, value: "data" },
        { text: "Dia Semana", align: "left", sortable: false, value: "diaSemana" },
        { text: "Função", align: "left", sortable: false, value: "funcao" },
        { text: "Descrição", align: "left", sortable: false, value: "descricao" },
        { text: "Ações", value: "name", sortable: false }
      ]
    };
  },
  watch: {
    cadastroEfetuado(event) {
      if (event) {
        setTimeout(() => {
          this.pesquisar();
          this.cadastroEfetuado = false;
        }, 500);
      }
    }
  },
  created() {
    this.carregarAnos();
  },
  methods: {
    async carregarAnos() {
      // RN001.1: lista todos os anos da instituição com plano cadastrado (não filtra por ativo).
      this.anos = (await qhPlanoService.listarAnos()) || [];
    },
    async aoSelecionarAno() {
      this.filtro.numero = null;
      this.plano = new QhPlanoResumo();
      this.recessos = [];
      if (this.filtro.ano) {
        this.numeros = await qhPlanoService.listarNumeros(this.filtro.ano);
      } else {
        this.numeros = [];
      }
    },
    async aoSelecionarNumero() {
      this.recessos = [];
      this.plano = new QhPlanoResumo();
      if (!this.filtro.numero) {
        return;
      }
      const paginacao = await qhPlanoService.listarTodos(
        { ano: this.filtro.ano, numero: this.filtro.numero }, 1, 1
      );
      if (paginacao && paginacao.dados && paginacao.dados.length > 0) {
        this.plano = new QhPlanoResumo(paginacao.dados[0]);
        this.pesquisar();
      }
    },
    async pesquisar() {
      if (!this.plano.id) {
        this.recessos = [];
        return;
      }
      this.loading = true;
      this.recessos = (await qhRecessoService.listarPorPlano(this.plano.id)) || [];
      this.loading = false;
    },
    editar(linha) {
      EventBus.$emit("editaQhRecesso", linha.id);
    },
    excluir(linha) {
      confirm("Deseja realmente excluir o registro de recesso?") &&
        qhRecessoService.excluir(linha).then(retorno => {
          if (retorno) {
            this.pesquisar();
          }
        });
    }
  }
};
</script>
<style scoped>
/* mesma estratégia da HU 002 (issue #147): scroll só na lista, não na tela */
.qh-recessos-scroll {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: auto;
}
</style>
